export default class ModalOpener {
  constructor({ el, isLargeQuery }) {
    this.el = el;
    this.isLargeQuery = isLargeQuery;

    this.init();
  }

  init() {
    this.el.addEventListener('click', (e) => {
      e.preventDefault();

      // get data modal attribute
      const modalId = this.el.getAttribute('data-modal');
      const modalEl = document.getElementById(modalId);

      if (modalId && modalId !== 'false') {
        // open modal
        document.body.style.overflow = 'hidden';
        modalEl.classList.add('active');
      }
    });
  }
}
